import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { createUpsellProduct, loadCategories, loadMenus, loadProducts } from "../../../actions";

class CreateUpsellProductModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: this.props.modalData.show,
            selectedMenu: -1,
            selectedCategory: -1,
            selectedProduct: -1,
            disableSubmit: false
        }
    }

    componentDidMount() {
        this.props.loadMenus(this.props.restaurantId);
    }

    loadCategories = (menuId) => {
        this.setState({
            ...this.state,
            selectedMenu: menuId,
            selectedCategory: -1,
            selectedProduct: -1
        }, () => {
            this.props.loadCategories(menuId);
        })
    };

    loadProducts = (categoryId) => {
        this.setState({
            ...this.state,
            selectedCategory: categoryId,
            selectedProduct: -1
        }, () => {
            this.props.loadProducts(categoryId);
        })
    };

    selectProduct = (productId) => {
        this.setState({
            ...this.state,
            selectedProduct: productId
        })
    };

    toggle = (refresh) => {
        this.setState({
            ...this.state,
            show: !this.state.show
        }, () => {
            setTimeout(() => {
                this.props.toggleModal(refresh);
            }, 500);
        });
    };

    saveUpsellProduct = (productDraftId) => {
        this.setState({
            ...this.state,
            disableSubmitButton: true
        }, () => {
            this.props.createUpsellProduct(this.props.restaurantId, productDraftId, () => { this.toggle(true) });
        })
    };

    render() {
        const { categories, title, categoriesContainer, list, item, selectedItem, inactiveItem } = style;
        return (
            <Modal isOpen={this.state.show} toggle={this.toggle} style={{ maxWidth: 800 }}>
                <ModalHeader toggle={this.toggle} className="modalHeader">{i18n.t('screens:upsellScreen.selectProduct')}</ModalHeader>
                <ModalBody>
                    <div style={categoriesContainer}>
                        <div style={categories}>
                            <div style={title}>{i18n.t('screens:menuScreen.heading')}</div>
                            <ul style={list}>
                                {this.props.menus.map(menu => {
                                    return (
                                        <li style={this.state.selectedMenu === menu.id ? selectedItem : menu.active ? item : inactiveItem} onClick={() => this.loadCategories(menu.id)}>{menu.name}</li>
                                    )
                                })}
                            </ul>
                        </div>
                        <div style={categories}>
                            <div style={title}>{i18n.t('screens:categoryScreen.heading')}</div>
                            <ul style={list}>
                                {this.props.categories.map(category => {
                                    return (
                                        <li style={this.state.selectedCategory === category.id ? selectedItem : category.active ? item : inactiveItem} onClick={() => this.loadProducts(category.id)}>{category.name}</li>
                                    )
                                })}
                            </ul>
                        </div>
                        <div style={categories}>
                            <div style={title}>{i18n.t('screens:productScreen.heading')}</div>
                            <ul style={list}>
                                {this.props.products.map(product => {
                                    let skip = false;
                                    this.props.upsellProducts.map(addedProduct => {
                                        if (addedProduct.productDraft.id === product.id) {
                                            skip = true;
                                        }
                                    });
                                    if (skip) {
                                        return null;
                                    } else {
                                        return (
                                            <li style={this.state.selectedProduct === product.id ? selectedItem : product.active ? item : inactiveItem}
                                                onClick={() => this.selectProduct(product.id)}>{product.sizeName ? `${product.sizeName} ` : ''}{product.name}</li>
                                        )
                                    }
                                })}
                            </ul>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => { this.saveUpsellProduct(this.state.selectedProduct) }}
                        disabled={this.state.selectedProduct === -1 || this.state.disableSubmit}
                    >
                        <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />
                        &nbsp;{i18n.t('common:buttons.addProduct')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    return {
        menus: state.menus,
        categories: state.categories,
        products: state.products
    }
};

export default connect(mapStateToProps, {
    loadMenus,
    loadCategories,
    loadProducts,
    createUpsellProduct
})(CreateUpsellProductModal);

const style = {
    categoriesContainer: {
        display: 'flex',
    },
    categories: {
        width: 'calc(100% / 3)',
        padding: 5
    },
    title: {

    },
    list: {
        width: '100%',
        height: 300,
        background: '#F0F0F0',
        borderTop: '1px solid black',
        padding: 0,
        margin: 0,
        listStyle: 'none',
        overflow: 'auto'
    },
    item: {
        padding: '5px 15px',
        borderBottom: "1px solid rgb(222, 226, 231)",
        cursor: 'pointer'
    },
    inactiveItem: {
        color: 'rgb(204, 204, 207)',
        padding: '5px 15px',
        borderBottom: "1px solid rgb(222, 226, 231)",
        cursor: 'pointer'
    },
    selectedItem: {
        background: '#fff',
        color: 'rgb(2, 136, 209)',
        padding: '5px 15px',
        borderBottom: "1px solid rgb(222, 226, 231)",
        cursor: 'pointer'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/upsell/CreateUpsellProductModal.js